import React, { useEffect, useState } from "react";
import "./bottomMenu.css";
import Config from "../../../src/service/Config/config";
import callWebService, {
  callTypes,
} from "../../../src/service/Networks/network.js";
import {
  ACCOUNT_LIST_URL,
  CAR_LOAN_B2B_FLOW,
  DARWIN_ATTENDANCE,
  DEALER_LIST_URL,
  JOURNEY_END_URL,
  JOURNEY_URL,
  LOGOUT_URL,
  TOLL_ACCOUNT_LIST_URL,
  VALET_ACCOUNT_LIST,
  VALET_PROJECT_LIST,
  isNewLeadX,
} from "../../utils/redirection.js";

const DashboardMenu = () => {
  const [roleId, setRoleId] = useState("");
  const [active, setActive] = useState([
    {
      home: false,
      dashboard: false,
      lead: false,
      delicated: false,
      assigned: false,
      changeAssignee: false,
      account: false,
      yourJourney: false,
      invitation: false,
      car_service: false,
      parking: false,
      activityApproval: false,
      regularisation: false,
      newParking: false,
      account_pending_approval: false,
      start_journey: false,
      end_journey: false,
      valet_existing_site: false,
      pjp_schedules: false,
      approval_pending_pjp: false,
      pjp_review: false,
      pjp_submission: false,
      pjp: false,
      approval_rejected_pjp: false,
      heatMap: false,
      ucdDealer: false,
      smScorecard: false,
      ucdLead: false,
      ucdApproval: false,
      location_approval_request: false,
      lead_approval_request: false,
      fusion: false,
      external_mom: false,
      transferAssignee: false,
    },
  ]);
  const [userId, setUserId] = useState(0);
  const [teams, setTeams] = useState([{}]);
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [isManager, setIsManager] = useState(false);
  const [attendanceTab, setAttendanceTab] = useState(false);
  const [fusionRedirectUrl, setFusionRedirectUrl] = useState("#");

  useEffect(() => {
    (async () => {
      setUserId(window.localStorage.user_id);
      let activePage = window.localStorage.active_page;
      active[activePage] = true;
      setActive(active);
      let userProfile = localStorage.getItem("user_profile");
      let userDetails = JSON.parse(userProfile);
      setIsManager(userDetails?.darwin_manager_check);
      setAttendanceTab(userDetails?.attendance_tab_flag);
      const teamIds = userDetails?.teams.map((team) => team.team_id);
      setTeams(teamIds);
      setRoleId(window.localStorage.role_id);
      if (parseInt(userDetails?.fusion_login_preference) === 2) {
        setFusionRedirectUrl(
          "https://play.google.com/store/search?q=fusion%20park%2B&c=apps&hl=en"
        );
      } else {
        setFusionRedirectUrl("https://fusion.parkplus.io/");
      }
      if (teamIds) {
        return;
      }
      const base_url = process.env.REACT_APP_API_URL;
      const role_id =
        window.localStorage.role_id ?? localStorage.getItem("role_id");
      let res = await callWebService(
        callTypes.get,
        "",
        `${Config?.getProfile}?source=leadx&roleId=${role_id}`
      );

      if (window.localStorage.token) {
        const base_url = process.env.REACT_APP_API_URL;
        const role_id =
          window.localStorage.role_id ?? localStorage.getItem("role_id");
        res = await callWebService(
          callTypes.get,
          "",
          `${Config?.getProfile}?source=leadx&roleId=${role_id}`
        );
      }

      const { data } = res;
      let webView = window.localStorage.webview;
      if (
        parseInt(data.response.status_code) === 401 ||
        parseInt(data.response.status_code) === 500
      ) {
        delete localStorage.clear();
        window.location.href = "/";
        if (webView !== undefined && webView == "true") {
          console.log("logout event fired");
          const message = {
            event_name: "logout_user",
            page: "dashboard menu profile",
          };
          const nativeObject = window.ReactNativeWebView;
          if (nativeObject !== undefined) {
            nativeObject.postMessage(JSON.stringify(message));
            window.addEventListener("message", () => {});
          }
        }
      }
      if (data.response.data) {
        localStorage.setItem(
          "user_profile",
          JSON.stringify(data?.response?.data)
        );
        // localStorage.setItem("role_id", JSON.stringify(data?.response?.data?.roles[0]?.pivot?.role_id));
        setRoleId(window.localStorage.role_id);
        setIsManager(data?.response?.data?.darwin_manager_check);
        setAttendanceTab(data?.response?.data?.attendance_tab_flag);
        setTimeout(() => {
          window.location.reload();
        }, 0);
      }
    })();
  }, []);

  useEffect(() => {
    let module_type = "";
    delete window.localStorage.journey_state;
    if (window.localStorage.role_id !== undefined) {
      let role = parseInt(window.localStorage.role_id);
      console.log(teams);
      if (role === 29 || role === 30 || role === 43) {
        module_type = "fasttag toll";
        window.localStorage.module_type = module_type;
      } else if (
        teams &&
        teams.includes(18) &&
        (role === 42 || role === 41 || role === 6 || role === 54)
      ) {
        module_type = "dealer";
        window.localStorage.module_type = module_type;
      } else if (
        teams &&
        teams.includes(28) &&
        (role === 42 || parseInt(role) === 41 || role === 6 || role === 54)
      ) {
        module_type = "UCD";
        window.localStorage.module_type = "UCD";
      }

      (async () => {
        const base_url = process.env.REACT_APP_API_URL;
        if (module_type != "") {
          const { data } = await callWebService(
            callTypes.get,
            "",
            `${Config?.getJourney}?module_type=${module_type}`
          );
          if (data.response.data) {
            window.localStorage.journey_state = "End";
          }
        }
      })();
    }
  }, [window.localStorage.module_type, teams]);

  const handleLogout = (e) => {
    e.preventDefault();
    let webView = window.localStorage.webview;
    localStorage.clear();
    if (isNewLeadX()) {
      window.location.href = LOGOUT_URL;
    } else if (webView !== undefined && webView == "true") {
      console.log("logout event fired");
      const message = {
        event_name: "logout_user",
        page: "dashboard menu logout",
      };
      const nativeObject = window.ReactNativeWebView;
      if (nativeObject !== undefined) {
        nativeObject.postMessage(JSON.stringify(message));
        window.addEventListener("message", () => {});
      }
    } else {
         window.location.href="/"
    }
  };

  const handleActivePage = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  const handleActivePageCheck = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  const handleActiveSubMenuCheck = (subMenu) => {
    setActiveSubMenu(activeSubMenu === subMenu ? null : subMenu);
  };

  return (
    <>
      <nav
        id="sidebar"
        className="dashboard-nav"
        style={{ overflow: "scroll" }}
      >
        <div className="sidebar-header">
          <h3>
            <img
              src="https://fusion.parkplus.io/favicon.webp"
              className="rounded-circle hw"
              alt=""
            />{" "}
            LeadX
          </h3>
        </div>

        <ul className="list-unstyled components">
          <li className={active["home"] ? "active" : ""}>
            <a
              href="/home"
              onClick={() => {
                handleActivePage("home");
              }}
            >
              <i className="bi bi-house"></i>&nbsp;&nbsp;Home
            </a>
          </li>
          {(attendanceTab || isManager) && (
            <>
              {/* attendance tab starts */}
              <li>
                <a
                  className={activeMenu === "attendance" ? "active" : ""}
                  onClick={() => handleActivePageCheck("attendance")}
                >
                  <i className="fas fa-calendar-check"></i>
                  &nbsp;&nbsp;Attendance&nbsp;&nbsp;&nbsp;&nbsp;
                  <i
                    className={`bi ${
                      activeMenu === "attendance"
                        ? "bi-caret-up-fill"
                        : "bi-caret-down-fill"
                    }`}
                  ></i>
                </a>
                <div
                  className={`list-unstyled components ${
                    activeMenu === "attendance" ? "" : "d-none"
                  }`}
                >
                  <>
                    <a
                      className={`bi bi-briefcase-fill ${
                        activeSubMenu === "outOfOffice" ? "active" : ""
                      }`}
                      href="/not-at-site-attendance"
                    >
                      &nbsp;&nbsp;Check-in/out
                    </a>
                    <a
                      className={`bi bi-file-text-fill ${
                        activeMenu === "attendanceRecord" ? "active" : ""
                      }`}
                      href="/monthly-regularization"
                    >
                      &nbsp;&nbsp;Attendance Record
                    </a>
                  </>
                      {(isManager == true) && (
                    <>
                      <a
                        className={`bi bi-check-square-fill ${
                                      activeMenu === "regularizationRequests" ? "active" : ""
                        }`}
                        href="/manager-requests-list"
                      >
                        &nbsp;&nbsp;Request List
                      </a>
                      <a
                        className={`bi bi-list-task ${
                                      activeMenu === "regularizationRequestsLogs" ? "active" : ""
                        }`}
                        href="/request-list-logs"
                      >
                        &nbsp;&nbsp;Attendance Logs
                      </a>
                    </>
                  )}
                </div>
              </li>
              {/* attendance tab ends */}
            </>
          )}
          <li className={active["dashboard"] ? "active" : ""}>
            <a
              href="/dashboard"
              onClick={() => {
                handleActivePage("dashboard");
              }}
            >
              <i className="bi bi-speedometer2"></i>&nbsp;&nbsp;Dashboard
            </a>
          </li>

          <li className={active["fusion"] ? "active" : ""}>
            <a
              href={`${fusionRedirectUrl}`}
              onClick={() => {
                handleActivePage("fusion");
              }}
              target="_blank"
            >
              <i className="bi bi-speedometer2"></i>&nbsp;&nbsp;Fusion
            </a>
          </li>
          {/*{(parseInt(roleId) === 5 || parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 16 || parseInt(roleId) === 4) &&*/}
          {/*    <li className={active['lead'] ? 'active' : ''}>*/}
          {/*        <a href="/lead-List" onClick={() => {*/}
          {/*            handleActivePage("lead")*/}
          {/*        }}><i className="bi bi-cursor"></i>&nbsp;&nbsp;Lead</a>*/}
          {/*    </li>*/}
          {/* } */}
          {parseInt(roleId) == 79 && (
            <>
              <li className={active["leads"] ? "active" : ""}>
                <a
                  href="/leads"
                  onClick={() => {
                    handleActivePage("leads");
                  }}
                >
                  <i className="fa fa-users"></i>&nbsp;&nbsp;Leads Management
                </a>
              </li>
            </>
          )}

          {(parseInt(roleId) === 29 ||
            parseInt(roleId) === 30 ||
            parseInt(roleId) === 43 ||
            parseInt(roleId) === 41 ||
            parseInt(roleId) === 42 ||
            parseInt(roleId) === 6 ||
            parseInt(roleId) === 54 ||
            parseInt(roleId) === 55 ||
            parseInt(roleId) === 67) && (
            <>
              <li className={active["yourJourney"] ? "active" : ""}>
                <a
                  href="/get-journey"
                  onClick={() => {
                    handleActivePage("yourJourney");
                  }}
                >
                  <i className="fas fa-building"></i>&nbsp;&nbsp;Journey Stats
                </a>
              </li>
              {window.localStorage.journey_state === undefined && (
                <li className={active["start_journey"] ? "active" : ""}>
                  <a
                    href={isNewLeadX()? JOURNEY_URL + `?module_type=${localStorage.getItem("module_type")}` : "/journey"}
                    onClick={() => {
                      handleActivePage("start_journey");
                    }}
                  >
                    <i className="fas fa-plane-departure"></i>&nbsp;&nbsp;Start
                    Journey
                  </a>
                </li>
              )}

              {window?.localStorage?.journey_state &&
                window?.localStorage?.journey_state === "End" && (
                  <li className={active["end_journey"] ? "active" : ""}>
                    <a
                      href={isNewLeadX()? JOURNEY_END_URL  + `?module_type=${localStorage.getItem("module_type")}` : "/journey"}
                      onClick={() => {
                        handleActivePage("end_journey");
                      }}
                    >
                      <i className="fas fa-plane-arrival"></i>&nbsp;&nbsp;End
                      Journey
                    </a>
                  </li>
                )}
              {(parseInt(roleId) === 29 ||
                parseInt(roleId) === 30 ||
                parseInt(roleId) === 43 ||
                parseInt(roleId) === 67) && (
                <>
                  <li className={active["account"] ? "active" : ""}>
                    <a
                      href={isNewLeadX()? TOLL_ACCOUNT_LIST_URL :"/fast-tag-toll-list" }
                      onClick={() => {
                        handleActivePage("account");
                      }}
                    >
                      <i className="bi bi-person-fill"></i>&nbsp;&nbsp;Toll
                    </a>
                  </li>
                  <li
                    className={
                      active["account_pending_approval"] ? "active" : ""
                    }
                  >
                    <a
                      href="/fast-tag-toll-list/is_approval"
                      onClick={() => {
                        handleActivePage("account_pending_approval");
                      }}
                    >
                      <i className="far fa-lightbulb"></i>&nbsp;&nbsp;Meeting
                      Request Raised
                    </a>
                  </li>
                </>
              )}

              {parseInt(roleId) === 29 && (
                <>
                  {/*<li className={active['pjp_schedules'] ? 'active' : ''}>*/}
                  {/*    <a href={`/pjp-approved-list/${userId}`} onClick={() => {*/}
                  {/*        handleActivePage("pjp_schedules")*/}
                  {/*    }}><i className="fa fa-check" aria-hidden="true"></i>*/}
                  {/*        &nbsp;&nbsp;Scheduled PJP</a>*/}
                  {/*</li>*/}
                  <li className={active["pjp_review"] ? "active" : ""}>
                    <a
                      href={`/pjp-review`}
                      onClick={() => {
                        handleActivePage("pjp_review");
                      }}
                    >
                      <i className="fa fa-eye" aria-hidden="true"></i>
                      &nbsp;&nbsp;PJP
                    </a>
                  </li>
                </>
              )}

              {parseInt(roleId) === 43 && (
                <>
                  <li className={active["pjp_review"] ? "active" : ""}>
                    <a
                      href={`/pjp-review`}
                      onClick={() => {
                        handleActivePage("pjp_review");
                      }}
                    >
                      <i className="fa fa-eye" aria-hidden="true"></i>
                      &nbsp;&nbsp;PJP Status
                    </a>
                  </li>
                </>
              )}

              {parseInt(roleId) === 67 && (
                <>
                  {/*<li className={active['pjp'] ? 'active' : ''}>*/}
                  {/*    <a href={`/pjp-approved-list`} onClick={() => {*/}
                  {/*        handleActivePage("pjp")*/}
                  {/*    }}><i className='far fa-lightbulb'></i>&nbsp;&nbsp;PJP Submission</a>*/}
                  {/*</li>*/}
                  {/*<li className={active['approval_pending_pjp'] ? 'active' : ''}>*/}
                  {/*    <a href={`/pjp-pending-list`} onClick={() => {*/}
                  {/*        handleActivePage("approval_pending_pjp")*/}
                  {/*    }}><i className='far fa-lightbulb'></i>&nbsp;&nbsp;Pending Approval PJP</a>*/}
                  {/*</li>*/}
                  <li className={active["pjp_review"] ? "active" : ""}>
                    <a
                      href={`/pjp-review`}
                      onClick={() => {
                        handleActivePage("pjp_review");
                      }}
                    >
                      <i className="fa fa-eye" aria-hidden="true"></i>
                      &nbsp;&nbsp;PJP Approval
                    </a>
                  </li>
                  {/*<li className={active['approval_rejected_pjp'] ? 'active' : ''}>*/}
                  {/*    <a href={`/pjp-rejected-list`} onClick={() => {*/}
                  {/*        handleActivePage("approval_rejected_pjp")*/}
                  {/*    }}><i className="fa fa-ban" aria-hidden="true"></i>*/}
                  {/*        &nbsp;&nbsp;Rejected PJP</a>*/}
                  {/*</li>*/}
                </>
              )}

              {(parseInt(roleId) === 30 || parseInt(roleId) === 43) && (
                <>
                  <li className={active["pjp_submission"] ? "active" : ""}>
                    <a
                      href={`/pjp-submission`}
                      onClick={() => {
                        handleActivePage("pjp_submission");
                      }}
                    >
                      <i className="fa fa-check" aria-hidden="true"></i>
                      &nbsp;&nbsp;PJP Submission
                    </a>
                  </li>
                  <li className={active["pjp_review"] ? "active" : ""}>
                    <a
                      href={`/pjp-review`}
                      onClick={() => {
                        handleActivePage("pjp_review");
                      }}
                    >
                      <i className="fa fa-eye" aria-hidden="true"></i>
                      &nbsp;&nbsp;PJP Status
                    </a>
                  </li>
                  {/*<li className={active['approval_rejected_pjp'] ? 'active' : ''}>*/}
                  {/*    <a href={`/pjp-rejected-list/`} onClick={() => {*/}
                  {/*        handleActivePage("approval_rejected_pjp")*/}
                  {/*    }}><i className="fa fa-ban" aria-hidden="true"></i>*/}
                  {/*        &nbsp;&nbsp;Rejected PJP</a>*/}
                  {/*</li>*/}
                </>
              )}
            </>
          )}

          {/*{(parseInt(roleId) === 46 || parseInt(roleId) === 47) &&*/}
          {/*    <>*/}
          {/*        <a href="/valet_account-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;New Sites</a>*/}
          {/*        <a href="/valet-existing-sites"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;Existing Sites</a>*/}
          {/*        <a href="/external-mom-listing"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;External*/}
          {/*            Mom</a>*/}
          {/*    </>*/}
          {/*}*/}

          {(parseInt(roleId) === 43 ||
            parseInt(roleId) === 30 ||
            parseInt(roleId) === 29) && (
            <li className={active["activityApproval"] ? "active" : ""}>
              <a
                href="/approved-pending-list"
                onClick={() => {
                  handleActivePage("activityApproval");
                }}
              >
                <i className="bi bi-person-fill"></i>&nbsp;&nbsp;Approval
                Pending
              </a>
            </li>
          )}
          {roleId &&
            parseInt(roleId) !== 41 &&
            parseInt(roleId) !== 42 &&
            parseInt(roleId) !== 29 &&
            parseInt(roleId) !== 30 &&
            parseInt(roleId) !== 43 &&
            parseInt(roleId) !== 46 &&
            parseInt(roleId) !== 47 &&
            parseInt(roleId) !== 35 &&
            parseInt(roleId) !== 36 &&
            parseInt(roleId) !== 37 &&
            parseInt(roleId) !== 38 &&
            parseInt(roleId) !== 48 &&
            parseInt(roleId) !== 15 &&
            parseInt(roleId) !== 17 &&
            parseInt(roleId) !== 19 &&
            parseInt(roleId) !== 14 &&
            parseInt(roleId) !== 54 &&
            parseInt(roleId) !== 55 && (
              <li className={active["account"] ? "active" : ""}>
                <a
                  href={isNewLeadX()? ACCOUNT_LIST_URL : "/list-account"}
                  onClick={() => {
                    handleActivePage("account");
                  }}
                >
                  <i className="bi bi-person-fill"></i>&nbsp;&nbsp;Account
                </a>
              </li>
            )}

          {(parseInt(roleId) === 15 ||
            parseInt(roleId) === 17 ||
            parseInt(roleId) === 16 ||
            parseInt(roleId) === 14 ||
            parseInt(roleId) === 56) && (
            <li className={active["account"] ? "active" : ""}>
              <a
                href="/ba-account-list"
                onClick={() => {
                  handleActivePage("account");
                }}
              >
                <i className="bi bi-person-fill"></i>&nbsp;&nbsp;BA Sites
              </a>
            </li>
          )}

          {(parseInt(roleId) === 35 ||
            parseInt(roleId) === 36 ||
            parseInt(roleId) === 37 ||
            parseInt(roleId) === 38 ||
            parseInt(roleId) === 48) && (
            <>
              <li className={active["parking"] ? "active" : ""}>
                <a
                  href="/parking-account-list"
                  onClick={() => {
                    handleActivePage("parking");
                  }}
                >
                  <i className="bi bi-person-fill"></i>&nbsp;&nbsp;Existing
                  Parking
                </a>
              </li>
              <li className={active["newParking"] ? "active" : ""}>
                <a
                  href="/new-parking-account-list"
                  onClick={() => {
                    handleActivePage("parking");
                  }}
                >
                  <i className="bi bi-person-fill"></i>&nbsp;&nbsp;New Parking
                </a>
              </li>
            </>
          )}

          {(parseInt(roleId) === 46 || parseInt(roleId) === 47 || parseInt(roleId) === 76) && (
            <>
              <li className={active["account"] ? "active" : ""}>
                <a
                  href={isNewLeadX()? VALET_ACCOUNT_LIST :"/valet_account-list"}
                  onClick={() => {
                    handleActivePage("account");
                  }}
                >
                  <i className="bi bi-person-fill"></i>&nbsp;&nbsp;New Sites
                </a>
              </li>
              <li className={active["valet_existing_site"] ? "active" : ""}>
                <a
                  href={isNewLeadX()? VALET_PROJECT_LIST :"/valet-existing-sites"}
                  onClick={() => {
                    handleActivePage("valet_existing_site");
                  }}
                >
                  <i className="bi bi-person-fill"></i>&nbsp;&nbsp;Existing Site
                </a>
              </li>
              <li className={active["external_mom"] ? "active" : ""}>
                <a
                  href="/external-mom-listing"
                  onClick={() => {
                    handleActivePage("external_mom");
                  }}
                >
                  <i className="bi bi-person-fill"></i>&nbsp;&nbsp;External MOM
                </a>
              </li>
            </>
          )}

          {/* for car service */}
          {(parseInt(roleId) === 6 ||
            parseInt(roleId) === 7 ||
            parseInt(roleId) === 4 ||
            parseInt(roleId) === 5) && (
            <li className={active["car_service"] ? "active" : ""}>
              <a
                href="/car-service-account-list"
                onClick={() => {
                  handleActivePage("car_service");
                }}
              >
                <i className="bi bi-person-fill"></i>&nbsp;&nbsp;Car Service
              </a>
            </li>
          )}

          {(parseInt(roleId) === 5 ||
            parseInt(roleId) === 6 ||
            parseInt(roleId) === 7 ||
            parseInt(roleId) === 16 ||
            parseInt(roleId) === 4 ||
            parseInt(roleId) === 17 ||
            parseInt(roleId) === 15 || 
            parseInt(roleId) === 41) && (
            <>
              <li className={active["delicated"] ? "active" : ""}>
                <a
                  href="/task-list/1"
                  onClick={() => {
                    handleActivePage("delicated");
                  }}
                >
                  <i className="bi bi-card-checklist"></i>&nbsp;&nbsp;Create
                  Task
                </a>
              </li>
              <li className={active["assigned"] ? "active" : ""}>
                <a
                  href="/task-list/2"
                  onClick={() => {
                    handleActivePage("assigned");
                  }}
                >
                  <i className="fas fa-tasks"></i>&nbsp;&nbsp;Assigned Task
                </a>
              </li>
              <li className={active["heatMap"] ? "active" : ""}>
                <a
                  href="/heatmap"
                  onClick={() => {
                    handleActivePage("heatMap");
                  }}
                >
                  <i className="bi bi-geo-alt-fill"></i>&nbsp;&nbsp;Park+
                  Heatmap
                </a>
              </li>
            </>
          )}

          {parseInt(roleId) === 42 && (
            <li className={active["delicated"] ? "active" : ""}>
              <a
                href="/task-list/1"
                onClick={() => {
                  handleActivePage("delicated");
                }}
              >
                <i className="bi bi-card-checklist"></i>&nbsp;&nbsp;Create Task
              </a>
            </li>
          )}
          {(parseInt(roleId) === 41 ||
            parseInt(roleId) === 42 ||
            parseInt(roleId) === 6 ||
            parseInt(roleId) === 54 ||
            parseInt(roleId) === 55) && (
            <>
              {teams && teams.includes(18) && (
                <>
                  <li className={active["lead"] ? "active" : ""}>
                    <a
                      href="/dealer-lead-list"
                      onClick={() => {
                        handleActivePage("lead");
                      }}
                    >
                      <i className="bi bi-cursor"></i>&nbsp;&nbsp;NCD Lead
                    </a>
                  </li>
                  <li className={active["account"] ? "active" : ""}>
                    <a
                      href={isNewLeadX()? DEALER_LIST_URL : "/dealer-list/ncd"}
                      onClick={() => {
                        handleActivePage("account");
                      }}
                    >
                      <i className="bi bi-person-fill"></i>&nbsp;&nbsp;NCD
                      Dealer
                    </a>
                  </li>
                </>
              )}

              {(parseInt(roleId) === 41 || parseInt(roleId) === 42) && (
                <li className={active["delicated"] ? "active" : ""}>
                  <a
                    href="/task-list/2"
                    onClick={() => {
                      handleActivePage("delicated");
                    }}
                  >
                    <i className="fas fa-tasks"></i>&nbsp;&nbsp;Assigned Task
                  </a>
                </li>
              )}

              {parseInt(roleId) === 42 && (
                <li className={active["lead_approval_request"] ? "active" : ""}>
                  <a
                    href="/dsm-lead-pending"
                    onClick={() => {
                      handleActivePage("lead_approval_request");
                    }}
                  >
                    <i className="fas fa-tasks"></i>&nbsp;&nbsp;Lead Request
                  </a>
                </li>
              )}

              {parseInt(roleId) === 55 && (
                <li
                  className={
                    active["location_approval_request"] ? "active" : ""
                  }
                >
                  <a
                    href="/dsm-lead-address-approval-list"
                    onClick={() => {
                      handleActivePage("location_approval_request");
                    }}
                  >
                    <i className="fas fa-tasks"></i>&nbsp;&nbsp;Location Request
                  </a>
                </li>
              )}

              {teams && teams.includes(28) && (
                <>
                  <li className={active["ucdLead"] ? "active" : ""}>
                    <a
                      href="/ucd-lead-list"
                      onClick={() => {
                        handleActivePage("ucdLead");
                      }}
                    >
                      <i className="bi bi-person-fill"></i>&nbsp;&nbsp;UCD Lead
                    </a>
                  </li>
                  {parseInt(roleId) === 54 && (
                    <li className={active["ucdApproval"] ? "active" : ""}>
                      <a
                        href="/ucd-lead-pending-list"
                        onClick={() => {
                          handleActivePage("ucdApproval");
                        }}
                      >
                        <i className="bi bi-person-fill"></i>&nbsp;&nbsp;Lead
                        Approval
                      </a>
                    </li>
                  )}
                  {/* <li className={active['ucdDealer'] ? 'active' : ''}>
                                    <a href="/ucd-dealer-list" onClick={() => {
                                        handleActivePage("ucdDealer")
                                    }}><i className="bi bi-person-fill"></i>&nbsp;&nbsp;UCD Dealer</a>
                                </li> */}

                  {/* ucd dealer tab starts */}
                  <li>
                    <a
                      className={activeMenu === "ucdDealer" ? "active" : ""}
                      onClick={() => handleActivePageCheck("ucdDealer")}
                    >
                      <i className="fas fa-building"></i>
                      &nbsp;&nbsp;UCD Dealer&nbsp;&nbsp;&nbsp;&nbsp;
                      <i
                        className={`bi ${
                          activeMenu === "ucdDealer"
                            ? "bi-caret-up-fill"
                            : "bi-caret-down-fill"
                        }`}
                      ></i>
                    </a>
                    <div
                      className={`list-unstyled components ${
                        activeMenu === "ucdDealer" ? "" : "d-none"
                      }`}
                    >
                      <>
                        <a
                          className={`bi bi-clock-fill ${
                            activeSubMenu === "pending" ? "active" : ""
                          }`}
                          href="/ucd-dealer-list"
                        >
                          &nbsp;&nbsp;Pending Dealer
                        </a>
                        <a
                          className={`bi bi-check-circle-fill ${
                            activeSubMenu === "approved" ? "active" : ""
                          }`}
                          href="/ucd-approval-list"
                        >
                          &nbsp;&nbsp;Verified Dealer
                        </a>
                        <a
                          className={`bi bi-check-circle-fill ${
                            activeSubMenu === "approved" ? "active" : ""
                          }`}
                          href="/ucd-unverified-list"
                        >
                          &nbsp;&nbsp;Un-verified Dealer
                        </a>
                      </>
                    </div>
                  </li>

                {(parseInt(roleId) === 41 ||
                  parseInt(roleId) === 54) && (
                  <>
                    <li className="">
                      <a
                        href={`${CAR_LOAN_B2B_FLOW}?roleId=${roleId}&auth_token=${window.localStorage.getItem(
                          "token"
                        )}&refresh_token=${window.localStorage.getItem(
                          "refresh_token"
                        )}&source=parkplus_leadx_webview`}
                      >
                        <i className="fa fa-eye" aria-hidden="true"></i>
                        &nbsp;&nbsp;Check PA offer
                      </a>
                    </li>
                  </>
                )}
                  {/* ucd dealer tab ends */}

                  {(parseInt(roleId) === 54 || parseInt(roleId) === 55) && (
                    <li className={active["transferAssignee"] ? "active" : ""}>
                      <a
                        href="/ucd-change-assignee"
                        onClick={() => {
                          handleActivePage("transferAssignee");
                        }}
                      >
                        <i className="bi bi-arrow-left-right"></i>
                        &nbsp;&nbsp;Transfer Assignee
                      </a>
                    </li>
                  )}
                </>
              )}
            </>
          )}
          {/* { (parseInt(roleId) === 55 || parseInt(roleId) === 65 || parseInt(roleId) === 66) && (
                {(parseInt(roleId) === 55 || parseInt(roleId) === 65 || parseInt(roleId) === 66) && (
                    <li className={active['usersList'] ? 'active' : ''}>
                        <a href="/users-list" onClick={() => {
                            handleActivePage("usersList")
                        }}><i className="bi bi-star"></i>&nbsp;&nbsp;Rating</a>
                    </li>
                )}
                {(parseInt(roleId) !== 55 && parseInt(roleId) !== 65 && parseInt(roleId) !== 66) && (
                    <>
                        <li className={active['smScorecard'] ? 'active' : ''}>
                            <a href="/sm-list/" onClick={() => {
                                handleActivePage("smScorecard")
                            }}><i className="bi bi-star-fill"></i>&nbsp;&nbsp;Self Scorecard</a>
                        </li>

                        <li className={active['rmDetails'] ? 'active' : ''}>
                            <a href="/rm-details" onClick={() => {
                                handleActivePage("rmDetails")
                            }}><i className="fa fa-address-card"></i>&nbsp;&nbsp;Rating</a>
                        </li>
                    </>
                )} */}

          {/* rating tab starts */}
          <li>
            <a
              className={activeMenu === "ratingTree" ? "active" : ""}
              onClick={() => handleActivePageCheck("ratingTree")}
            >
              <i className="bi bi-star-fill"></i>
              &nbsp;&nbsp;Rate&nbsp;&nbsp;&nbsp;&nbsp;
              <i
                className={`bi ${
                  activeMenu === "ratingTree"
                    ? "bi-caret-up-fill"
                    : "bi-caret-down-fill"
                }`}
              ></i>
            </a>
            <div
              className={`list-unstyled components ${
                activeMenu === "ratingTree" ? "" : "d-none"
              }`}
            >
              {parseInt(roleId) !== 55 &&
                parseInt(roleId) !== 65 &&
                parseInt(roleId) !== 66 && (
                  <>
                    <a
                      className={`bi bi-file-earmark-fill ${
                        activeSubMenu === "scorecard" ? "active" : ""
                      }`}
                      href="/sm-list"
                    >
                      &nbsp;&nbsp;Self Scorecard
                    </a>
                    <a
                      className={`bi bi-star-fill ${
                        activeSubMenu === "rating" ? "active" : ""
                      }`}
                      href="/rm-details"
                    >
                      &nbsp;&nbsp;Rating
                    </a>
                  </>
                )}
              {(parseInt(roleId) === 55 ||
                parseInt(roleId) === 65 ||
                parseInt(roleId) === 66) && (
                <a
                  className={`bi bi-star-fill ${
                    activeSubMenu === "rating" ? "active" : ""
                  }`}
                  href="/users-list"
                >
                  &nbsp;&nbsp;Rating
                </a>
              )}
            </div>
          </li>
          {/* rating tab ends */}

          {/* <li className={active['raiseIssue'] ? 'active' : ''}>
                    <a href="/raise-issue" onClick={() => {
                        handleActivePage("raiseIssue")
                    }}><i className="fa fa-question-circle"></i>&nbsp;&nbsp;Raise Issue</a>
                </li>

                <li className={active['ticketList'] ? 'active' : ''}>
                    <a href="/ticket-details" onClick={() => {
                        handleActivePage("ticketList")
                    }}><i className="fas fa-ticket-alt"></i>&nbsp;&nbsp;Ticket List</a>
                </li> */}
          {/* ticket tab starts */}
          <li>
            <a
              className={activeMenu === "ticket" ? "active" : ""}
              onClick={() => handleActivePageCheck("ticket")}
            >
              <i className="fas fa-ticket-alt"></i>
              &nbsp;&nbsp;Ticket&nbsp;&nbsp;&nbsp;&nbsp;
              <i
                className={`bi ${
                  activeMenu === "ticket"
                    ? "bi-caret-up-fill"
                    : "bi-caret-down-fill"
                }`}
              ></i>
            </a>
            <div
              className={`list-unstyled components ${
                activeMenu === "ticket" ? "" : "d-none"
              }`}
            >
              <a
                className={`bi bi-patch-question-fill ${
                  activeSubMenu === "raiseIssue" ? "active" : ""
                }`}
                href="/raise-issue"
              >
                &nbsp;&nbsp;Raise Issue
              </a>
              <a
                className={`bi bi-list-check ${
                  activeSubMenu === "ticketList" ? "active" : ""
                }`}
                href="/ticket-details"
              >
                &nbsp;&nbsp;Ticket List
              </a>
            </div>
          </li>
          {/*ticket   tab ends */}

          {parseInt(roleId) !== 41 &&
            parseInt(roleId) !== 42 &&
            parseInt(roleId) !== 54 &&
            parseInt(roleId) !== 55 && (
              <li className={active["changeAssignee"] ? "active" : ""}>
                <a
                  href="/assignment"
                  onClick={() => {
                    handleActivePage("changeAssignee");
                  }}
                >
                  <i className="fas fa-handshake"></i>&nbsp;&nbsp;Change
                  Assigneem1
                </a>
              </li>
            )}

          <li className={active["invitation"] ? "active" : ""}>
            <a
              href="/tagged-along-activity"
              onClick={() => {
                handleActivePage("invitation");
              }}
            >
              <i className="fas fa-handshake"></i>&nbsp;&nbsp;Tag Along
              Approvals
            </a>
          </li>

          <li className={active["regularisation"] ? "active" : ""}>
            <a
              href="/attendance-regularization-request"
              onClick={() => {
                handleActivePage("regularisation");
              }}
            >
              <i className="fa fa-bolt"></i>&nbsp;&nbsp;Attendance
              Regularisation
            </a>
          </li>

          <li className={active["referrals"] ? "active" : ""}>
            <a
              href="/referrals-options"
              onClick={() => {
                handleActivePage("referrals");
              }}
            >
              <i className="fa fa-user-plus"></i>&nbsp;&nbsp;Referrals
            </a>
          </li>

          <li className="">
            <a
              href="#"
              className="logout"
              onClick={(e) => {
                handleLogout(e);
              }}
            >
              <i className="fas fa-sign-out-alt"></i>&nbsp;&nbsp;Logout
            </a>
          </li>
        </ul>

        {/* <ul class="list-unstyled CTAs">
                <li>
                    <a href="https://bootstrapious.com/tutorial/files/sidebar.zip" class="download">Download source</a>
                </li>
                <li>
                    <a href="https://bootstrapious.com/p/bootstrap-sidebar" class="article">Back to article</a>
                </li>
            </ul> */}
      </nav>
    </>
  );
};
export default DashboardMenu;
